import React, { ReactElement } from "react";
import Campaign from "../../components/Campaign";
import Layout from "../../components/layout";

const CampaignPage = (): ReactElement => {
  return (
    <Layout>
      <Campaign />
    </Layout>
  );
};

export default CampaignPage;
